import { takeLatest, put, call, all } from 'redux-saga/effects';
import get from 'lodash/get';
import { updateCartItem } from 'yoda-interfaces/lib/Cart/CartApi';
import ItemCountActions from 'yoda-site-components/lib/actions/ItemCountAction';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { SET_SERVICE_ERROR } from 'yoda-site-components/lib/common/Constants';
import LoadingAction from 'yoda-site-components/lib/actions/LoadingAction';
import { showGlobalLoader } from '../actions/ShowGlobalLoaderAction';
import { digitalAnalyticsData } from '../actions/CheckoutAnalyticsAction';
// import { UPDATE_ANALYTICS_CLICK_EVENT } from '../actionTypes/CheckoutAnalyticsActionTypes';
import { ADDTOCART_DETAILS_GET_REQUEST } from '../actionTypes/AddToCartInterstitialActionTypes';
import {
    ITEM_UPDATE_REQUEST,
    ITEM_UPDATE_ERROR,
    CART_DETAILS_GET_REQUEST,
} from '../actionTypes/CartItemUpdateActionTypes';

function* cartItemUpdateSaga(action) {
    yield put(LoadingAction.showLoader());
    const result = yield call(FactorySaga, updateCartItem, action);
    yield put(LoadingAction.removeLoader());
    if (result.isSuccess) {
        const itemQuantityUpdate = {
            cartUpdate: {
                productId: action.payload.id,
                serviceType: action.payload.serviceType,
                RemovedChildItems: action.payload.RemovedChildItems,
            },
        };

        const DAEventAction = get(action, 'payload.optionalAddOrUpdateEvent', '');
        yield all([
            put({ type: ADDTOCART_DETAILS_GET_REQUEST, payload: '', DAPayload: { DAEventAction } }),
            put(ItemCountActions.updateItemCountAction()),
            put({ type: CART_DETAILS_GET_REQUEST, ATCPayload: { pageFrom: 'ATC_SECTION' } }),
            // DA ==> to Fire careplanAccept
            // put({ type: UPDATE_ANALYTICS_CLICK_EVENT, payload: Constants.ANALYTICS.ACTIONS.UPDATE_CART }),
        ]);
        // eslint-disable-next-line no-unused-expressions
        DAEventAction ? yield put(digitalAnalyticsData(itemQuantityUpdate)) : '';
    } else {
        yield put({ type: ITEM_UPDATE_ERROR, result });
        yield put(showGlobalLoader(false));
        /** handle ServiceError Message Box in ATC Slider */
        const { errorHandler } = action.payload;
        errorHandler.errorComponent = 'ATC_SECTION';
        errorHandler.key = 'ATC_SECTION';
        yield put({ type: SET_SERVICE_ERROR, errorHandlerInfo: errorHandler });
    }
}

const watchcartItemUpdateSaga = function* watchcartItemUpdateSaga() {
    yield takeLatest(ITEM_UPDATE_REQUEST, cartItemUpdateSaga);
};

watchcartItemUpdateSaga.sagaName = 'cartItemUpdateSaga';

export default watchcartItemUpdateSaga;
